import * as images from "@/components/images/Images";

export const INDUSTRIES = [
    {
      title: "Law",
      icon: images.law_icon,
      href: "/use-cases/legal",
    },
    {
      title: "Education",
      icon: images.education_icon,
      href: "/use-cases/academic",
    },
    {
      title: "Finance",
      icon: images.solar_wallet,
      href: "/use-cases/financial",
    },
    {
      title: "Government",
      icon: images.fluent_building,
      href: "/industries/government",
    },
    {
      title: "Healthcare",
      icon: images.helthcare_icon,
      href: "/use-cases/medical",
    },
    {
      title: "Technical",
      icon: images.education_icon,
      href: "/use-cases/technical",
    },
  ];